import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    display: 'flex',
    paddingBottom: pxToRem(8),
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    marginBottom: pxToRem(8),
  },
  noSpacing: {
    marginBottom: 0,
  },
  noBorder: {
    borderBottom: 'none',
  },
});
